import index from "vue-global-events";

const state = {
  hotelObj: null,
  updateActiveIndex:null,
  hotelRoomObj:null,
  selCancelPolicy:null,
  ratePlan: null,
  activeTabIndex:null,
  selHotelRoomObj:null,
  selSurcharge:null,
  hotelLang:null,
  selCancelPolicyEditDelete:null,
  lsBedTypes:null
 

  
};

const getters = {


  GET_SEL_HOTEL_ROOM_OBJ:(state) =>{
          return state.selHotelRoomObj
  },
  GET_HOTEL_LANG: (state) => {
    return state.hotelLang;
  },
  GET_CANCEL_POLICY: (state) => {
    return state.selCancelPolicy;
  },
  GET_CANCEL_POLICY_DELETE: (state) => {
    return state.selCancelPolicyEditDelete;
  },
  GET_RATE_PLAN: (state) => {
    return state.ratePlan;
  },
  GET_HOTEL_OBJ: (state) => {
    return state.hotelObj;
  },
  GET_ACTIVE_INDEX: (state) => {
    return state.updateActiveIndex;
  },
  GET_HOTEL_ROOM_OBJ: (state) => {
    return state.hotelRoomObj;
  },
  GET_ACTIVE_TAB_INDEX: (state) => {
    return state.activeTabIndex;
  },
  GET_SEL_SURCHARGE:(state)=>{
    return state.selSurcharge
  },
  GET_BED_TYPES:(state)=>{
    return state.lsBedTypes
  }
};
const actions = {
  CLEAR_HOTEL_INFO_STORE: ({ commit }, obj) => {
    commit("clearHotelInfoStore", obj);
  },
  SET_HOTEL_LANG: ({ commit }, obj) => {
    commit("saveHotelLang", obj);
  },

  SET_SEL_HOTEL_ROOM_OBJ:({commit},obj)=>{
     commit('saveSelHotelRoom',obj)
  },
  SET_CANCEL_POLICY: ({ commit }, obj) => {
    commit("saveSelCancelPolicy", obj);
  },
  SET_CANCEL_POLICY_DELETE: ({ commit }, obj) => {
    commit("saveCancelPolicyEditDelete", obj);
  },
  SET_RATE_PLAN: ({ commit }, obj) => {
    commit("saveRatePlan", obj);
  },
  SET_HOTEL_OBJ: ({ commit }, obj) => {
    commit("saveHotelObj", obj);
  },
  SET_ACTIVE_INDEX: ({ commit }, index) => {
    commit("saveActiveIndex", index);
  },

  SET_HOTEL_ROOM_OBJ:({commit},obj)=>{
    commit("saveHotelRoomObj", obj);
  },
  SET_ACTIVE_TAB: ({ commit }, tab) => {
    commit("saveActiveTab", tab);
  },
SET_SEL_SURCHARGE:({commit},obj)=>{
    commit('saveSelSurcharge',obj)
},

SET_BED_TYPES:({commit},val)=>{
  commit('saveBedTypes',val)
}

};
const mutations = {
  clearHotelInfoStore: (state) => {
    state.hotelObj = null;
    state.updateActiveIndex=null;
    state.hotelRoomObj = null
    state.selCancelPolicy=null;
    state.ratePlan = null;
    state.selSurcharge=null
    state.hotelLang = null;
    state.selHotelRoomObj=null;
    state.selCancelPolicyEditDelete=null;
    state.lsBedTypes=null
  },
  saveBedTypes:(state,val)=>{
    state.lsBedTypes=val 
  }
,
  saveSelHotelRoom:(state,obj)=>{
         state.selHotelRoomObj=obj
  },
  saveHotelLang: (state, obj) => {
    state.hotelLang = obj;
  },
  saveRatePlan: (state, obj) => {
    state.ratePlan = obj;
  },
  saveSelCancelPolicy: (state, obj) => {
    state.selCancelPolicy = obj;
  },
  saveCancelPolicyEditDelete: (state, obj) => {
    state.selCancelPolicyEditDelete = obj;
  },
  saveHotelObj: (state, obj) => {
    state.hotelObj = obj;
  },
  saveActiveIndex: (state, index) => {
    state.updateActiveIndex = index;
  },

  saveHotelRoomObj:(state,obj)=>{

    state.hotelRoomObj=obj
  },
  saveActiveTab: (state, index) => {
    state.activeTabIndex = index;
  },
  saveSelSurcharge:(state,obj)=>{
    state.selSurcharge=obj
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
